type Path = { path: string; title?: string };

export const pathMap = {
  BodyZones: 'body-zones',
  Decks: '/decks',
  Exercises: '/exercises',
  EditExercise: '/edit-exercise',
  ExerciseDetails: '/exercise-details',
  ExerciseCategories: '/exercise-categories',
  Glossary: '/glossary',
  Plans: '/plans',
  Plan: '/plan-viewer',
  QRCode: '/qr-code',
};

const paths: Array<Path> = [
  { path: pathMap.Decks, title: 'Decks' },
  { path: pathMap.Plans, title: 'Plans' },
  { path: pathMap.Plan, title: 'Plan' },
  { path: pathMap.EditExercise },
  { path: pathMap.ExerciseDetails, title: 'Exercise Details' },
  { path: pathMap.QRCode, title: 'QR-Code' },
  { path: '/equipment', title: 'Equipment' },
  { path: '/support', title: 'Support' },
  { path: '/trainees', title: 'Trainees' },
  { path: pathMap.Exercises, title: 'Exercises' },
  { path: pathMap.ExerciseCategories, title: 'Exercise Categories' },
  { path: '/my-account', title: 'My Account' },
  { path: pathMap.BodyZones, title: 'Body Zones' },
  { path: '/user-guide', title: 'User Guide' },
  { path: '/users', title: 'User Management' },
  { path: '/trainee-assignment', title: 'Trainee Assignment' },
  { path: '/maintenance', title: 'Maintenance' },
  { path: '/history', title: 'Training History' },
  { path: '/thesaurus', title: 'Thesaurus' },
];

export const getPathObject = (path: string) => {
  const pathObj = paths.find((po) => path.startsWith(po.path));
  return pathObj?.title;
};
